export const inventoryAcceptedFormats = [
  { extension: '.csv', mimeType: 'text/csv' },
  { extension: '.xlsx', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
]
